import React, { useEffect } from 'react'
import {
  FocusableComponentLayout,
  setFocus,
} from '@noriginmedia/norigin-spatial-navigation'
import tts from '../../lib/TTS'
import FocusableLink from '../../components/FocusableLink'
import type { SettingsAboutProps } from './types'

const LINKS = [
  {
    key: 'privacyPolicyModal',
    label: 'Privacy Policy',
    onActivate: (setters: SettingsAboutProps) => {
      setters.setPrivacyVisible()
    },
  },
  {
    key: 'termsOfUseModal',
    label: 'Terms of Use',
    onActivate: (setters: SettingsAboutProps) => {
      setters.setTermsOfVisible()
    },
  },
  {
    key: 'closedCaptionModal',
    label: 'Closed Caption Support',
    onActivate: (setters: SettingsAboutProps) => {
      setters.setClosedCaptionVisible()
    },
  },
]
const TITLE = 'About'

const SettingsAbout = (props: SettingsAboutProps) => {
  const { handleFocus, returnFocusKey } = props

  const handleTtsFocus =
    (label: string) => (layout: FocusableComponentLayout) => {
      tts.stopRead()
      tts.addTextToRead(`${TITLE}. Focused on ${label}.`)

      handleFocus?.(layout)
    }

  useEffect(() => {
    if (returnFocusKey) {
      setFocus(returnFocusKey)
    }
  }, [returnFocusKey])

  return (
    <div className="settings-section-container">
      <h2>{TITLE}</h2>

      {LINKS.map(({ key, label, onActivate }) => (
        <FocusableLink
          key={key}
          focusKey={key}
          label={label}
          onFocus={
            key === 'privacyPolicyModal' ? handleTtsFocus(label) : handleFocus
          }
          onEnterPress={() => onActivate(props)}
          disableTTS={key === 'privacyPolicyModal' ? true : false}
        >
          <div className="about">
            <h3>{label}</h3>
          </div>
        </FocusableLink>
      ))}
    </div>
  )
}

export default SettingsAbout
